import Vue from "vue";
import Router from "vue-router";
import Splash from "@/layouts/Splash";
import AuthLayout from 'bh-mod/layouts/Auth'
import store from "@/store";
import { VueAppMiddleware, setupAiApi } from "bh-mod";
import AppLayout from "bh-mod/layouts/App";

Vue.use(Router);
const router = new Router({
	base: process.env.BASE_URL,
	mode: "history",
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/",
			component: AppLayout,
			meta: { instanceRequired: true, auth: true, hidden: true },
			children: [
				// Dashboards
				{
					path: "/",
					meta: {
						title: "AI Agent List",
						sidebar: true,
						dataRequired: true,
						crumbName: "AI Agent List",
					},
					component: () => import("./views/app"),
				},
				{
					path: "/call-history",
					meta: {
						title: "Call History",
						sidebar: true,
						dataRequired: true,
						crumbName: "Call History",
					},
					component: () => import("./views/callHistory/index.vue"),
				},
				{
					path: "/call-history/:id",
					meta: {
						title: "Call Details",
						sidebar: true,
						dataRequired: true,
						crumbName: "Call Details",
					},
					component: () => import("./views/callHistory/details.vue"),
				},
				{
					path: "/agent/new",
					meta: {
						title: "Create AI Agent",
						sidebar: true,
						dataRequired: true,
						crumbName: "Create AI Agent",
					},
					component: () => import("./views/app/agent.vue"),
				},
				{
					path: "/agent/edit/:id",
					meta: {
						title: "Edit AI Agent",
						sidebar: true,
						dataRequired: true,
						crumbName: "Edit AI Agent",
					},
					component: () => import("./views/app/agent.vue"),
				},
				{
					path: "/knowledgeBase",
					meta: {
						title: "Knowledge Base",
						sidebar: true,
						dataRequired: true,
						crumbName: "AI Agent Knowledge Base",
					},
					component: () => import("./views/knowledgeBase"),
				},

				{
					path: '/settings',
					meta: {
						title: 'Settings',
						sidebar: true,
						dataRequired: true,
						crumbName: "Settings",
					},
					component: () =>
						import('./views/settings/index.vue'),
				},
				{
					path: "/notifications",
					meta: {
						title: "All Notifications",
						sidebar: true,
						dataRequired: true,
						crumbName: "All Notifications",
					},
					component: () => import("bh-mod/components/layout/TopBar/Notifications/notifications.vue"),
				},
			],
		},
		{
			path: "/setup",
			component: Splash,
			meta: { hidden: true, splash: true },
			children: [
				{
					path: "/setup",
					meta: {
						title: "Setup AI Agent",
						splashScreen: true,
						crumbName: "Setup AI Agent",
					},
					component: () => import("./views/setup"),
				},
			],
		},
		{
			path: '/404',
			component: Splash,
			children: [
				{
					path: '/404',
					meta: {
						title: 'Error 404',
						crumbName: "Error 404",
					},
					component: () => import('bh-mod/components/common/404.vue'),
				}
			]
		},
		{
			path: '/unauthorized',
			component: AuthLayout,
			children: [
				{
					path: '/unauthorized',
					meta: {
						title: 'Unauthorized',
						unauthorized: true,
						crumbName: "Unauthorized",
					},
					component: () => import('bh-mod/components/common/unauthorized.vue'),
				}
			]
		},
		// Other routes...
		{
			// Catch-all route: This will match any invalid route
			path: '*',
			redirect: '/404'
		}
	],
});

let hiveRequested = false;
let isAiApiSetup = false;
router.beforeEach(async (to, from, next) => {
	let dataRequired = to.matched.some(record => record.meta.dataRequired)
	let splashScreen = to.matched.some(record => record.meta.splashScreen)
	let unauthorized = to.matched.some(record => record.meta.unauthorized)
	let error = false

	if (!hiveRequested) {
		let response = await VueAppMiddleware(to, store, 'ai')
		error = response.parsed
		hiveRequested = true;
	}

	if (!isAiApiSetup) {
		setupAiApi()
		isAiApiSetup = true
	}

	if (error) {
		if (error === 'User does not have required permission!') {
			return next('/unauthorized')
		}
		return console.error('ERROR', error)
	} else {
		if (unauthorized) {
			return next();
		}

		if (to.path !== '/404') {
			if (!store.getters.isAIEnabled) {
				return next('/unauthorized')
			}
			if (to.path.startsWith('/call-history') && !store.getters.isAIAdvanceAddOn) {
				return next('/unauthorized')
			}
		}

		const seenIntro = store.state.appData.allSettings?.userApp?.options?.seenIntro;

		if (splashScreen && seenIntro) {
			return next('/')
		} else if (dataRequired && !seenIntro && !store.state.appData.getStarted) {
			return next('/setup')
		}

		next();
	}
	next();
});

export default router;
